import { useEffect, useState } from "react";

export const ClientOnly = ({ children }: React.PropsWithChildren) => {
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        setIsClient(true);
    }, []);

    if (!isClient) return null;
    return children;
};
